$(document).ready(function() {

	if( $('.HomePage .banner .slides .slide').length > 1 ){
		
		numSlides = $('.HomePage .banner .slides').children('.slide').length - 1;
		currentSlide = numSlides;
		nextSlide = 1;
		
		// run function on load
		changeSlides( 'timer' );
		
		// initiate timed slide
		var setSliderTimer = setInterval( changeSlides, 4500 );	
	}

});

function changeSlides( mode, destination ){
		
	// if at last element
	if( currentSlide == numSlides ){
		nextSlide = 0;
	}else{
		nextSlide = currentSlide + 1;
	}
	
	// --- UPDATE SLIDER
	
	// move all to bottom
	$('.HomePage .banner .slides .slide').css({ 'z-index' : 1 });
	
	// move current on top of bottom stack
	$('.HomePage .banner .slides .slide:eq(' + currentSlide + ')').css({ 'z-index' : 2 });
	
	// move destination to top with 0% opacity and then animate in
	$('.HomePage .banner .slides .slide:eq(' + nextSlide + ')').css({ 'z-index' : 3, 'opacity' : 0 }).animate({ 'opacity' : 1 }, 200);
	
	// --- UPDATE COUNTER
	currentSlide = nextSlide;
	
}